// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__10UTJ","footer":"ModalCreateQualiphyProcedure_footer__2gP1u","additionData":"ModalCreateQualiphyProcedure_additionData__2VA0z"};